import { observer } from 'mobx-react';
import { FC } from 'react';

import { provide, useDependencies } from '@servicetitan/react-ioc';
import { CenteredSpinner } from '@servicetitan/standalone-ui';
import { Loader } from '@servicetitan/web-components';

import { CampaignManagementStore } from '../stores/campaign-management.store';

export const CampaignManagementPage: FC = provide({
    singletons: [CampaignManagementStore],
})(
    observer(() => {
        const [{ data, source, basename }] = useDependencies(CampaignManagementStore);

        return (
            <Loader
                basename={basename}
                src={source}
                loadingFallback={<CenteredSpinner />}
                className="w-100"
                data={data}
            />
        );
    }),
);
